import Grid from '@mui/material/Grid';
import { ReactNode } from 'react';
import { TypographyWithEllipsisTooltip } from '../TypographyWithEllipsisTooltip';

const getStyles = (noWrap: boolean) => ({
  actionsRoot: {
    '& button': {
      '& span': {
        ml: {
          sm: -0.5,
          xs: 0,
        },
        mr: {
          sm: 1,
          xs: 0,
        },
      },
      '& svg': {
        height: '24px',
        width: '24px',
      },
      height: '47px',
      minWidth: 'fit-content',
    },
    paddingRight: '0 !important',
  },
  rightSide: {
    paddingRight: '0 !important',
    pt: noWrap ? '0 !important' : undefined,
    whiteSpace: noWrap ? 'nowrap' : 'normal',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 3.5,
  },
});

interface ITitle {
  dataTestId?: string;
  heading: ReactNode;
  leftSide?: ReactNode;
  noWrap?: boolean;
  rightSide?: ReactNode;
  rightSideActions?: ReactNode;
}

const Title = ({ dataTestId, heading, leftSide, noWrap, rightSide, rightSideActions }: ITitle) => {
  const styles = getStyles(!!noWrap);
  const flexWrap = noWrap ? 'nowrap' : undefined;
  const minWidth = noWrap ? '1px' : undefined;

  return (
    <Grid container spacing={2} sx={styles.root} flexWrap={flexWrap}>
      <Grid container size={{ sm: 'grow', xs: 10 }} flexWrap={flexWrap} minWidth={minWidth}>
        {leftSide && <Grid>{leftSide}</Grid>}
        <Grid minWidth={minWidth}>
          <TypographyWithEllipsisTooltip component="div" data-testid={dataTestId} sx={{ mb: 2 }} variant="h4">
            {heading}
          </TypographyWithEllipsisTooltip>
        </Grid>
      </Grid>
      <Grid>
        <Grid container spacing={2}>
          {rightSide && <Grid sx={styles.rightSide}>{rightSide}</Grid>}
          {rightSideActions && <Grid sx={styles.actionsRoot}>{rightSideActions}</Grid>}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Title;
